// src/hooks/useInitialData.ts
import { useEffect, useState } from 'react';
import { useTeamStore } from '../stores/teamStore';

export const useInitialData = () => {
  const { fetchUsers, fetchRoles, initialized } = useTeamStore();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      console.log('useInitialData - Start', { initialized, isLoading });
      
      if (initialized) {
        console.log('useInitialData - Already initialized, skipping');
        return;
      }
      
      setIsLoading(true);
      try {
        console.log('useInitialData - Fetching roles...');
        await fetchRoles();
        
        console.log('useInitialData - Fetching users...');
        await fetchUsers();
        
        console.log('useInitialData - Data loaded successfully');
      } catch (error) {
        console.error('useInitialData - Error:', error);
      } finally {
        setIsLoading(false);
        console.log('useInitialData - Loading finished');
      }
    };

    loadData();
  }, [fetchRoles, fetchUsers, initialized]);

  return { isLoading };
};
